/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface TagBitMaskResponse
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_TagBitMaskResponse_bitMaskData")("string")(() => {
    const regex = new RegExp(/^0x[a-f0-9]+$/);
    return (value: string) => !!regex.exec(value);
});
export interface TagBitMaskResponse {
    /**
     * BitMask as a base16 (hex) string
     * #type string
     * #memberof TagBitMaskResponse
        
        
    * @pattern_TagBitMaskResponse_bitMaskData
         */
    bitMaskData: string;
}
/**
 * Check if a given object implements the TagBitMaskResponse interface.
 */
export function instanceOfTagBitMaskResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bitMaskData" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const TagBitMaskResponseTypiaAssertEquals = (input: any) => {
    return ((input: any): TagBitMaskResponse => {
        const __is = (input: any, _exceptionable: boolean = true): input is TagBitMaskResponse => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.bitMaskData && $is_custom("pattern_TagBitMaskResponse_bitMaskData", "string", "", input.bitMaskData) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["bitMaskData"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is TagBitMaskResponse => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.bitMaskData && ($is_custom("pattern_TagBitMaskResponse_bitMaskData", "string", "", input.bitMaskData) || $guard(_exceptionable, {
                    path: _path + ".bitMaskData",
                    expected: "string (@pattern_TagBitMaskResponse_bitMaskData)",
                    value: input.bitMaskData
                })) || $guard(_exceptionable, {
                    path: _path + ".bitMaskData",
                    expected: "string",
                    value: input.bitMaskData
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["bitMaskData"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "TagBitMaskResponse",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "TagBitMaskResponse",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const TagBitMaskResponseTypiaAssertStringify = (input: TagBitMaskResponse): string => {
    return ((input: any): string => { const assert = (input: any): TagBitMaskResponse => {
        const __is = (input: any): input is TagBitMaskResponse => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).bitMaskData && $is_custom("pattern_TagBitMaskResponse_bitMaskData", "string", "", (input as any).bitMaskData));
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is TagBitMaskResponse => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => "string" === typeof input.bitMaskData && ($is_custom("pattern_TagBitMaskResponse_bitMaskData", "string", "", input.bitMaskData) || $guard(_exceptionable, {
                    path: _path + ".bitMaskData",
                    expected: "string (@pattern_TagBitMaskResponse_bitMaskData)",
                    value: input.bitMaskData
                })) || $guard(_exceptionable, {
                    path: _path + ".bitMaskData",
                    expected: "string",
                    value: input.bitMaskData
                });
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "TagBitMaskResponse",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "TagBitMaskResponse",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: TagBitMaskResponse): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        return `{"bitMaskData":${$string((input as any).bitMaskData)}}`;
    }; return stringify(assert(input)); })(input);
};
export const TagBitMaskResponseValidatorShape = {
    'bitMaskData': yup.string().matches(/^0x[a-f0-9]+$/).defined(),
};
export const TagBitMaskResponseValidator = yup.object().shape(TagBitMaskResponseValidatorShape);
export const TagBitMaskResponseStringifyShapeProperties: ObjectSchema['properties'] = {
    'bitMaskData': {
        'type': 'string',
        'pattern': "/^0x[a-f0-9]+$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
};
export const TagBitMaskResponseStringifyShape: ObjectSchema = {
    title: 'TagBitMaskResponse Stringifier',
    type: 'object',
    properties: {
        ...TagBitMaskResponseStringifyShapeProperties
    },
    required: [
        'bitMaskData',
    ],
};
export const TagBitMaskResponseStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(TagBitMaskResponseStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const TagBitMaskResponseStringify: (data: TagBitMaskResponse) => string = TagBitMaskResponseStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function TagBitMaskResponseFromJSON(json: any): TagBitMaskResponse {
    return TagBitMaskResponseFromJSONTyped(json, false);
}
export function TagBitMaskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagBitMaskResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'bitMaskData': json['bitMaskData'],
    };
}
export function TagBitMaskResponseToJSON(value?: TagBitMaskResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'bitMaskData': value.bitMaskData,
    };
}
